/**
 * RetailForgeLogo Component
 *
 * Brand logo component featuring a refined Erlenmeyer flask icon.
 * Represents the "forge" aspect of RetailForge - crafting retail solutions.
 * Used in dashboard header subtext and other brand attribution locations.
 */

interface RetailForgeLogoProps {
  /** Size of the logo in pixels (default: 16) */
  size?: number;
  /** Color of the icon (default: currentColor to inherit text color) */
  color?: string;
}

export function RetailForgeLogo({ size = 16, color = 'currentColor' }: RetailForgeLogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="RetailForge logo"
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
    >
      {/* Flask body - Erlenmeyer shape */}
      <path
        d="M9 2v6l-5 10a2 2 0 0 0 1.8 3h12.4a2 2 0 0 0 1.8-3l-5-10V2"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      {/* Flask neck cap */}
      <path
        d="M8 2h8"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      {/* Liquid level with bubbles effect */}
      <path
        d="M6.5 15h11"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        opacity="0.7"
      />
      {/* Bubble 1 */}
      <circle
        cx="10"
        cy="17"
        r="1"
        fill={color}
        opacity="0.5"
      />
      {/* Bubble 2 */}
      <circle
        cx="14"
        cy="16"
        r="0.75"
        fill={color}
        opacity="0.4"
      />
    </svg>
  );
}
